/* Form sub views */
import React from 'react';
import SchemaForm from 'components/util/schema_form/SchemaForm';
import { Loading } from 'seed/helpers';
import { LANDING_URL } from "settings"
import { FORM_STATUS } from './Form.lib';
import l from "components/util/l";

// Schema content component
const SchemaComponent = ({
  flowId,
  nodeId,
  formTitle,
  schema,
  validationMessage,
  onFormSubmit
}) =>
  <div class="card animate__animated animate__fadeInUp animate__faster">
    <div class="card-header">
      <h3>{formTitle != "" ? formTitle : l("Formulario%VA004", "Aa")}</h3>
    </div>
    <div class="card-body animated__animated animated_fadeIn">
      <SchemaForm
        flowId={flowId}
        nodeId={nodeId}
        onSubmit={onFormSubmit}
        schema={schema}
        submitText={l("Enviar%GA105")}
      />

      {validationMessage && 
        <div className='alert alert-soft-danger text-center mt-2 ml-8 mr-4 py-2'>{validationMessage}</div>}

      <a href={LANDING_URL} className='d-flex float-right mt-2 mr-3'>
        <span className='pr-2' style={{ color: '#70757a' }}>Powered by</span>
        <img class="z-index-2"
          src="/theme/svg/logos/logo.svg" alt="Logo" style={{ height: "1.1rem" }} />
      </a>
    </div>
  </div>

// Message content component
const Message = ({ icon, iconColor = "#607080", title, subtitle, cta }) =>
  <div class="text-center animate__animated animate__fadeInUp animate__faster">
    {icon && <i className={icon + " mb-5"} style={{ fontSize: "4em", color: iconColor }}></i>}
    {title && <h2>{title}</h2>}
    {subtitle && <p className='pb-0'>{subtitle}</p>}
    {cta && cta()}
  </div>

// Message component for different form statuses
const MessageComponent = ({
  flow,
  formStatus,
  reqUser
}) =>
  <div class="card py-5">
    <div class="card-body py-10">

      {formStatus == FORM_STATUS.LOADING &&
        <Loading />}

      {formStatus == FORM_STATUS.NOT_FOUND &&
        <Message
          title={l("Formulario no encontrado%VA019")}
          subtitle={l("Revisa el enlace o el acceso%VA020")}
          cta={() => !reqUser.data &&
            <a href={`/login?${flow?.token ?? ""}next=${encodeURIComponent(new URL(window.location.href).pathname)}`}
              className='btn btn-primary'>Iniciar sesión</a>} />}

      {formStatus == FORM_STATUS.ERROR &&
        <Message
          icon={"far fa-times-circle"}
          title={l("Ha ocurrido un error en el envío%VA007")}
          subtitle={l("Prueba de nuevo%VA008")} />}

      {formStatus == FORM_STATUS.COMPLETED &&
        <Message
          icon={"fas fa-check-circle"}
          iconColor={"#00C9A7"}
          title={l("Formulario enviado exitosamente%VA021")} />}
    </div>
  </div>

export { SchemaComponent, MessageComponent };